import styled from 'styled-components';
import { StickyContainer } from 'react-sticky';

const SmallCol =  styled(StickyContainer)`
	padding: 0 25px;
	max-width: 100%;
	flex-basis: 100%;

	@media (min-width: 1024px) {
		max-width: ${( 4.5/12 ) * 100}%;
		flex-basis: ${( 4.5/12 ) * 100}%;
	}

	@media (min-width: 1200px) {
		max-width: ${( 4/12 ) * 100}%;
		flex-basis: ${( 4/12 ) * 100}%;
	}
`;

export default SmallCol;
